// You can pass some outer data here
import ChooseFirstColorProduct from './components/choose-first-color-product';
import _ from 'lodash';
import { Message } from 'element-ui';
import router from '@/router';
import { request } from 'beans-admin-plugin';
import { PRODUCT_CATEGORY_LEVEL, PRODUCT_CATEGORY_SHOW_KIND } from '@/constants';

export default ({
  handleChooseFirstColorProductSuccess = _.noop,
  handleDeleteSuccess = _.noop,
  isEditPage = false,
  level = null,
  firstLevelCategories = [],
  secondLevelCategories = [],
  action = {},
  links = []
} = {}) => {
  // 不可创建一级分类
  const canCreateLevels = PRODUCT_CATEGORY_LEVEL;
  delete canCreateLevels['first_level'];

  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'name',
      label: '分类名',
      form: {
        component: 'input',
        required: true
      }
    },
    {
      prop: 'level',
      label: '级别',
      action: ['hide-in-table'],
      renderCell(h, { row }) {
        return <el-tag>{ PRODUCT_CATEGORY_LEVEL[row.level] }</el-tag>;
      },
      form: {
        component: 'select',
        required: true,
        props: {
          filterable: true,
          disabled: isEditPage,
          options: _.map(canCreateLevels, (label, value) => ({ label, value }))
        }
      }
    },
    level === 'second_level' && {
      prop: 'show_kind',
      label: '展示类型',
      renderCell(h, { row }) {
        return <el-tag>{ PRODUCT_CATEGORY_SHOW_KIND[row.show_kind] }</el-tag>;
      },
      form: {
        component: 'select',
        props: {
          options: _.map(PRODUCT_CATEGORY_SHOW_KIND, (label, value) => ({ label, value }))
        }
      }
    },
    level === 'third_level' && {
      prop: 'show_in_big_cover',
      label: '大图卡片展示',
      renderCell: 'bool',
      form: {
        component: 'switch'
      }
    },
    {
      prop: 'cover',
      label: '图片',
      renderCell: 'image',
      form: {
        component: 'upload',
        props: {
          hint: '左右图文展示图片建议尺寸80:80; 上下图文展示图片建议尺寸180x240; 大图建议尺寸560:auto'
        }
      }
    },
    {
      prop: 'first_color_product',
      label: '首个产品',
      renderCell(h, { row }) {
        return row.first_color_product && <c-link-button to={{ name: 'products.show', params: { id: row.first_color_product.product_id } }}>{row.first_color_product.name}</c-link-button>
      }
    },
    {
      prop: 'paren_name',
      label: '一级分类',
      action: ['hide-in-detail'],
      renderCell(h, { row }) {
        return row.level === 'second_level' ? row.parent_name : '';
      }
    },
    level === 'second_level' && {
      prop: 'parent_id',
      label: '一级分类',
      renderCell(h, { row }) {
        return row.parent_name;
      },
      form: {
        component: 'select',
        required: true,
        props: {
          filterable: true,
          options: firstLevelCategories.map(item => ({ value: item.id, label: item.name }))
        }
      }
    },
    level === 'third_level' && {
      prop: 'parent_id',
      label: '二级分类',
      action: ['hide-in-table'],
      renderCell(h, { row }) {
        return row.parent_name;
      },
      form: {
        component: 'select',
        required: true,
        props: {
          filterable: true,
          options: secondLevelCategories.map(item => ({ value: item.id, label: item.human_name }))
        }
      }
    },
    level === 'third_level' && {
      prop: 'link',
      label: '跳转链接',
      action: ['hide-in-table'],
      renderCell(h, { row }) {
        return row.link_name;
      },
      form: {
        component: 'select',
        props: {
          clearable: true,
          filterable: true,
          options: links
        }
      }
    },
    {
      prop: 'position',
      label: '权重',
      width: 80,
      form: {
        component: 'input',
        props: {
          placeholder: '从小到大排序'
        }
      }
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time',
      width: 120
    },
    {
      prop: 'updated_at',
      label: '更新时间',
      renderCell: 'time',
      width: 120
    },
    _.merge({
      prop: 'action',
      label: '操作',
      fixed: 'right',
      width: 220,
      detail: true,
      edit: true,
      delete: {
        async handler({ row }) {
          await request.delete(`/categories/${row.id}`);
          Message.success('删除分类完成');
          handleDeleteSuccess(row);
        }
      },
      extraAction(h, { row }) {
        return [
          row.level !== 'third_level' && {
            text: '添加子分类',
            handler: () => router.push({ name: 'categories.new', query: { parent_id: row.id, parent_level: row.level } })
          }
        ]
      },
      renderCell(h, { row }) {
        return (
          <ChooseFirstColorProduct
            id={row.id}
            firstColorProduct={row.first_color_product}
            onSuccess={() => handleChooseFirstColorProductSuccess()}
          />
        )
      }
    }, action)
  ].filter(Boolean);
}
